import { FC } from "react";

import { Stack } from "@mui/material";

import { RegisteredCharityStatement } from "@/canvas/components/RegisteredCharityStatement/RegisteredCharityStatement";
import { useFormV2Context } from "@/canvas/features/FormV2/contexts/FormV2Context";
import { FormDivider } from "@/forms-design-system/FormDivider";

export const FormRegisteredCharityStatement: FC = () => {
  const { formOrganization } = useFormV2Context();
  const registeredCharityDetails = formOrganization?.registeredCharityDetails;

  if (!registeredCharityDetails) {
    return null;
  }

  return (
    <Stack gap={3} paddingBlockStart={5} width="100%">
      <FormDivider />
      <RegisteredCharityStatement
        registeredName={registeredCharityDetails.registeredName}
        registrationNumber={registeredCharityDetails.registrationNumber}
      />
    </Stack>
  );
};
